import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IPaymentSwitchVerifyPinRequest } from '../../../entity/interface/iEntitlements';
import { CSRFTokenRequest } from '../../../entity';

export interface IPaymentSwitchVerifyPinUseCase {
    execute(
        payload: IPaymentSwitchVerifyPinRequest,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<any>;
}

export class PaymentSwitchVerifyPinUseCase implements IPaymentSwitchVerifyPinUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get paymentSwitchVerifyPinRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IPaymentSwitchVerifyPinRequest,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<any> {
        const response = await this.paymentSwitchVerifyPinRepository.paymentSwitchVerifyPin(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        return response.data.status.toLocaleLowerCase() === 'success' || false;
    }
}
